//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Constants } from '../../common/Constants';
import { IHttpInfo } from '../../logger';
import { newGuid } from '../../utilities/AppUtils';
import { AuthHelper } from '../../utilities/AuthHelper';
import { getAppHost } from '../../utilities/TeamsUtils';
import { tryParseAfdRefHeader } from '../../utilities/Utils';
import { HandleChallengeClaims } from '../ErrorHandling/HandleChallengeClaims';
export class ExtensibilityBaseClient {
    readonly clientRequestIdHeader = Constants.CLIENT_REQUESTID_HEADER;
    private startTime: number;
    private requestId: string;
    private method: string;

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = options.headers as any;
        headers.authorization = 'Bearer ' + (await AuthHelper.getApprovalsToken());

        if (!headers[this.clientRequestIdHeader]) {
            // set the clientRequestId if it's not present.
            headers[this.clientRequestIdHeader] = newGuid();
        }

        this.startTime = performance.now();
        this.requestId = headers[this.clientRequestIdHeader];
        this.method = options.method;

        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ): Promise<any> {
        const status = response ? response.status : 0;
        const edgeRef = tryParseAfdRefHeader(response);
        if (status >= 400 || status < 200) {
            console.error(`Server request failed, url: ${url}, status ${status}`);
            await HandleChallengeClaims(response);
        }

        const regex = /\/extensibility\/v1\/([a-zA-Z]+)/;
        const apiName = url.match(regex)[0].toString();

        // TODO: add host name
        const httpRequest: IHttpInfo = {
            apiName,
            url,
            clientRequestId: this.requestId,
            correlationId: this.requestId,
            latency: performance.now() - this.startTime,
            requestCreatedTime: this.startTime.toString(),
            responseCode: status,
            responseText: response.statusText,
            requestMethod: this.method,
            edgeRef,
        };

        getAppHost().getLogger().logHttp(httpRequest);
        return await processor(response);
    }

    protected getBaseUrl(token: string, baseUrl: string): string {
        return baseUrl ?? EXTENSIBILITY_SERVICE_ENDPOINT;
    }
}

export class AdaptiveCardClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get approval adaptive card template.
     * @param adaptiveCardTemplateUri (optional) Gets or sets a value indicating what endpoint to hit to fetch the adaptive card template.
     * @param provider (optional) Gets or sets a value indicating which LOB app config to use.
     * @param x_ms_client_request_id (optional) Gets or sets request GUID from client.
     * @return Approval Details.
     */
    getTemplate(adaptiveCardTemplateUri: string | null | undefined, provider: ClientProviderType | undefined, x_ms_client_request_id: string | undefined): Promise<GetAdaptiveCardTemplateControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/adaptivecard/template?";
        if (adaptiveCardTemplateUri !== undefined && adaptiveCardTemplateUri !== null)
            url_ += "AdaptiveCardTemplateUri=" + encodeURIComponent("" + adaptiveCardTemplateUri) + "&";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "Provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": x_ms_client_request_id !== undefined && x_ms_client_request_id !== null ? "" + x_ms_client_request_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTemplate(_response));
        });
    }

    protected processGetTemplate(response: Response): Promise<GetAdaptiveCardTemplateControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAdaptiveCardTemplateControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdaptiveCardTemplateControllerOutput>(null as any);
    }

    /**
     * Get approval adaptive card details map.
     * @param adaptiveCardDetailsUri (optional) Gets or sets a value indicating what endpoint to hit to fetch the adaptive card data.
     * @param provider (optional) Gets or sets a value indicating which LOB app config to use.
     * @param x_ms_client_request_id (optional) Gets or sets request GUID from client.
     * @return Approval Details.
     */
    getDetails(adaptiveCardDetailsUri: string | null | undefined, provider: ClientProviderType | undefined, x_ms_client_request_id: string | undefined): Promise<GetAdaptiveCardDetailsControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/adaptivecard/details?";
        if (adaptiveCardDetailsUri !== undefined && adaptiveCardDetailsUri !== null)
            url_ += "AdaptiveCardDetailsUri=" + encodeURIComponent("" + adaptiveCardDetailsUri) + "&";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "Provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": x_ms_client_request_id !== undefined && x_ms_client_request_id !== null ? "" + x_ms_client_request_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDetails(_response));
        });
    }

    protected processGetDetails(response: Response): Promise<GetAdaptiveCardDetailsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAdaptiveCardDetailsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdaptiveCardDetailsControllerOutput>(null as any);
    }
}

export class CancelApprovalClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Cancels an approval.
     * @param approvalId Approval Id to be deleted.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with canceled approval id with response confirmation.
     */
    userCancelApproval(approvalId: string, clientRequestId: string | undefined): Promise<CancelApprovalControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/basic/cancel/approvalId/{approvalId}";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserCancelApproval(_response));
        });
    }

    protected processUserCancelApproval(response: Response): Promise<CancelApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelApprovalControllerOutput>(null as any);
    }
}

export class CreateApprovalClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates a new approval.
     * @param input input from post body.
     * @param clientRequestId (optional) client request id passed as a header.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    userCreateApproval(input: CreateApprovalControllerInput, clientRequestId: string | undefined): Promise<CreateApprovalControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/basic/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserCreateApproval(_response));
        });
    }

    protected processUserCreateApproval(response: Response): Promise<CreateApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApprovalControllerOutput>(null as any);
    }
}

export class CreateApprovalsGroupClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates a new approvals group id.
     * @param input input from post body.
     * @param clientRequestId (optional) client request id passed as a header.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    userCreateApprovalsGroup(input: CreateApprovalsGroupControllerInput, clientRequestId: string | undefined): Promise<CreateApprovalsGroupControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/creategroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserCreateApprovalsGroup(_response));
        });
    }

    protected processUserCreateApprovalsGroup(response: Response): Promise<CreateApprovalsGroupControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApprovalsGroupControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApprovalsGroupControllerOutput>(null as any);
    }
}

export class FileAttachmentClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Downloads a file attached to an approval request.
     * @param attachmentDataUri (optional) Gets or sets a value indicating whether only active approvals to be returned in the list or all.
     * @param provider (optional) Gets or sets a value indicating which LOB app config to use.
     * @param x_ms_client_request_id (optional) Gets or sets request GUID from client.
     * @return Stream of file attachment data.
     */
    download(attachmentDataUri: string | null | undefined, provider: ClientProviderType | undefined, x_ms_client_request_id: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/attachment?";
        if (attachmentDataUri !== undefined && attachmentDataUri !== null)
            url_ += "AttachmentDataUri=" + encodeURIComponent("" + attachmentDataUri) + "&";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "Provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": x_ms_client_request_id !== undefined && x_ms_client_request_id !== null ? "" + x_ms_client_request_id : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class GetApprovalDetailsClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get Approval details by Approval Id.
     * @param approvalId id of approval request.
     * @param partnerId (optional) partner id associated with the approval request.
     * @param clientRequestId (optional) Client RequestId.
     * @return Approval Details.
     */
    userGetApprovalDetails(approvalId: string, partnerId: string | undefined, clientRequestId: string | undefined): Promise<GetApprovalDetailsControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/basic/getdetails/{approvalId}?";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserGetApprovalDetails(_response));
        });
    }

    protected processUserGetApprovalDetails(response: Response): Promise<GetApprovalDetailsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetApprovalDetailsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetApprovalDetailsControllerOutput>(null as any);
    }
}

export class ListApprovalsClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get list of approvals.
     * @param isActive (optional) Gets or sets a value indicating whether only active approvals to be returned in the list or all.
     * @param userRole (optional) Gets or sets the userRole for which listing should be done.
     * @param isDescending (optional) Gets or sets a value indicating whether descending or ascending order of the list should be returned.
     * @param nextLink (optional) Gets or sets the next link to query to get the remaining results.
     * @param maxNo (optional) Gets or sets the number of items in the list.
     * @param category (optional) Gets or sets the approval category for which listing should be done.
     * @param flowEnvironment (optional) Gets or sets the approval environment for which listing should be done.
     * @param flowEndpoint (optional) Gets or sets the flow endpoint.
     * @param partnerId (optional) Gets or sets the partner id associated with the list of approvals.
     * @param partnerIdQueryOperator (optional) Gets or sets the query operator of partner id.
     * @param expandHistory (optional) Gets or sets a value indicating whether to expand request history or not.
     * @param expandStages (optional) Gets or sets a value indicating whether to expand stages or not.
     * @param isvId (optional) Gets or sets the Isv id.
     * @param additionalFilters_Title (optional) Gets or sets the approval title for the additional filter.
     * @param additionalFilters_Details (optional) Gets or sets the approval details for the additional filter.
     * @param additionalFilters_Source (optional) Gets or sets the approval source for the additional filter.
     * @param excludeThumbnails (optional) Gets or sets a value indicating whether user profile thumbnails should be excluded from the response.
     * @param truncateProperties (optional) Gets or sets a value indicating whether propeties should truncate or not.
     * @param shouldSkipRetrievalOfMultiLineTextFields (optional) Gets or sets a value indicating whether multilinetextFields such as PartnerMetadata should be included in the response.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns Instance of ListApprovalsControllerOutput in Json format.
     */
    userListApprovals(isActive: boolean | null | undefined, userRole: ApprovalUserRole | undefined, isDescending: boolean | null | undefined, nextLink: string | null | undefined, maxNo: number | null | undefined, category: ApprovalCategory | undefined, flowEnvironment: string | null | undefined, flowEndpoint: string | null | undefined, partnerId: string | null | undefined, partnerIdQueryOperator: string | null | undefined, expandHistory: boolean | undefined, expandStages: boolean | undefined, isvId: string | null | undefined, additionalFilters_Title: string | null | undefined, additionalFilters_Details: string | null | undefined, additionalFilters_Source: string | null | undefined, excludeThumbnails: boolean | null | undefined, truncateProperties: boolean | null | undefined, shouldSkipRetrievalOfMultiLineTextFields: boolean | null | undefined, clientRequestId: string | undefined): Promise<ListApprovalsControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/basic/list?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (userRole === null)
            throw new Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "UserRole=" + encodeURIComponent("" + userRole) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (nextLink !== undefined && nextLink !== null)
            url_ += "NextLink=" + encodeURIComponent("" + nextLink) + "&";
        if (maxNo !== undefined && maxNo !== null)
            url_ += "MaxNo=" + encodeURIComponent("" + maxNo) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "FlowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        if (flowEndpoint !== undefined && flowEndpoint !== null)
            url_ += "FlowEndpoint=" + encodeURIComponent("" + flowEndpoint) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (partnerIdQueryOperator !== undefined && partnerIdQueryOperator !== null)
            url_ += "PartnerIdQueryOperator=" + encodeURIComponent("" + partnerIdQueryOperator) + "&";
        if (expandHistory === null)
            throw new Error("The parameter 'expandHistory' cannot be null.");
        else if (expandHistory !== undefined)
            url_ += "ExpandHistory=" + encodeURIComponent("" + expandHistory) + "&";
        if (expandStages === null)
            throw new Error("The parameter 'expandStages' cannot be null.");
        else if (expandStages !== undefined)
            url_ += "ExpandStages=" + encodeURIComponent("" + expandStages) + "&";
        if (isvId !== undefined && isvId !== null)
            url_ += "IsvId=" + encodeURIComponent("" + isvId) + "&";
        if (additionalFilters_Title !== undefined && additionalFilters_Title !== null)
            url_ += "AdditionalFilters.Title=" + encodeURIComponent("" + additionalFilters_Title) + "&";
        if (additionalFilters_Details !== undefined && additionalFilters_Details !== null)
            url_ += "AdditionalFilters.Details=" + encodeURIComponent("" + additionalFilters_Details) + "&";
        if (additionalFilters_Source !== undefined && additionalFilters_Source !== null)
            url_ += "AdditionalFilters.Source=" + encodeURIComponent("" + additionalFilters_Source) + "&";
        if (excludeThumbnails !== undefined && excludeThumbnails !== null)
            url_ += "ExcludeThumbnails=" + encodeURIComponent("" + excludeThumbnails) + "&";
        if (truncateProperties !== undefined && truncateProperties !== null)
            url_ += "TruncateProperties=" + encodeURIComponent("" + truncateProperties) + "&";
        if (shouldSkipRetrievalOfMultiLineTextFields !== undefined && shouldSkipRetrievalOfMultiLineTextFields !== null)
            url_ += "ShouldSkipRetrievalOfMultiLineTextFields=" + encodeURIComponent("" + shouldSkipRetrievalOfMultiLineTextFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserListApprovals(_response));
        });
    }

    protected processUserListApprovals(response: Response): Promise<ListApprovalsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListApprovalsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListApprovalsControllerOutput>(null as any);
    }
}

export class UpdateActionClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Takes update action on approval request.
     * @param clientRequestId (optional) Client request ID.
     * @param input Instance of UpdateActionControllerInput.
     * @return Instance of UpdateActionControllerOutput.
     */
    updateAction(clientRequestId: string | undefined, input: UpdateActionControllerInput): Promise<UpdateActionControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAction(_response));
        });
    }

    protected processUpdateAction(response: Response): Promise<UpdateActionControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateActionControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateActionControllerOutput>(null as any);
    }
}

export class UpdateApprovalClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Updates an approval with a response.
     * @param input instance of UpdateApprovalControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with updated approval id with response confirmation.
     */
    userUpdateApproval(input: UpdateApprovalControllerInput, clientRequestId: string | undefined): Promise<UpdateApprovalControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/basic/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserUpdateApproval(_response));
        });
    }

    protected processUserUpdateApproval(response: Response): Promise<UpdateApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateApprovalControllerOutput>(null as any);
    }
}

export class GetOperationClient extends ExtensibilityBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the operation associated with an approval action.
     * @param operationId The operation id associated with the approval action.
     * @return The operation object.
     */
    getOperation(operationId: string): Promise<GetOperationControllerOutput> {
        let url_ = this.baseUrl + "/extensibility/v1/approvals/scopes/service/operation/{operationId}";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOperation(_response));
        });
    }

    protected processGetOperation(response: Response): Promise<GetOperationControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOperationControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOperationControllerOutput>(null as any);
    }
}

/** Output data object for get Template controller. */
export interface GetAdaptiveCardTemplateControllerOutput {
    /** Gets or sets the template of adaptive card. */
    CardTemplate?: any | undefined;
}

/** The approval provider type. */
export enum ClientProviderType {
    NotSpecified = "NotSpecified",
    MsApprovals = "MsApprovals",
    Basic = "Basic",
    ESign = "ESign",
    SyntexESign = "SyntexESign",
}

/** Output data object for get adaptive card details controller. */
export interface GetAdaptiveCardDetailsControllerOutput {
    /** Gets or sets the details of adaptive card. */
    CardDetails?: any | undefined;
}

/** Data object used to call the cancel approval controller. */
export interface CancelApprovalControllerOutput {
    /** Gets or sets the id of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval. */
    Properties?: CancelApprovalOutputProperties | undefined;
}

/** Data object outlining response from flow's cancel approval API. */
export interface CancelApprovalOutputProperties {
    /** Gets or sets the title of the approval. */
    Title?: string | undefined;
    /** Gets or sets the owner of the approval. */
    Owner?: ApprovalCreatorOwner | undefined;
    /** Gets or sets the creator of the approval. */
    Creator?: ApprovalCreatorOwner | undefined;
    /** Gets or sets the result of the approval. */
    Result?: string | undefined;
    /** Gets or sets the creation date of the approval. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date of the approval. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date of the approval. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the completion date of the approval. */
    CompletionDate?: string | undefined;
    /** Gets or sets a value indicating whether ancelling is allowed. */
    AllowCancel: boolean;
    /** Gets or sets a value indicating whether reassigning is allowed. */
    AllowReassign: boolean;
    /** Gets or sets the status of the approval. */
    Status?: string | undefined;
    /** Gets or sets the stage of the approval. */
    Stage?: string | undefined;
}

/** Data object of owner within properties of the update approval response from flow. */
export interface ApprovalCreatorOwner {
    /** Gets or sets aad id of the owner of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the tenant id of the owner of the approval. */
    TenantId?: string | undefined;
}

/** Output data object for get approval controller. */
export interface GetApprovalDetailsControllerOutput {
    /** Gets or sets the name of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval view. */
    Properties?: ApprovalViewProperties | undefined;
}

/** Data object returned after creating approval. */
export interface CreateApprovalControllerOutput extends GetApprovalDetailsControllerOutput {
    /** Gets or sets the approvalId of request. */
    ApprovalId?: string | undefined;
}

/** The approval view properties. This is a translation of the approval entity into an object better suited to be consumed by the UI. */
export interface ApprovalViewProperties {
    /** Gets or sets the type of the approval. */
    Type?: ApprovalResponseType | undefined;
    /** Gets or sets a value indicating whether the approval is active or not. */
    IsActive: boolean;
    /** Gets or sets the roles of the user in the approval. */
    UserRoles?: ApprovalUserRole[] | undefined;
    /** Gets or sets the Owner of approval request. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets the creator, person who owns the connection. */
    Creator?: UserPrincipal | undefined;
    /** Gets or sets the userRequest of the approval. */
    UserRequest?: ApprovalRequestViewDefinition | undefined;
    /** Gets or sets the userRequest history of the approval. */
    UserRequestHistory?: ApprovalRequestHistoryDefinition[] | undefined;
    /** Gets or sets the responses of the approval. */
    Stages?: ApprovalStageViewDefinition[] | undefined;
    /** Gets or sets the title of the approval. */
    Title?: string | undefined;
    /** Gets or sets the description of the approval. */
    Details?: string | undefined;
    /** Gets or sets the result of the approval. */
    Result?: string | undefined;
    /** Gets or sets whether canceling the approval is allowed or not. */
    AllowCancel?: boolean | undefined;
    /** Gets or sets a value indicating whether EmailNotification are enabled or not. */
    EnableEmailNotifications?: boolean | undefined;
    /** Gets or sets whether request of the approval can be reassigned. */
    AllowReassign?: boolean | undefined;
    /** Gets or sets the optional item associated with an approval. */
    Item?: ApprovalItemDefinition | undefined;
    /** Gets or sets the optional link attachments associated with an approval. */
    TextAttachments?: ApprovalsTextAttachment[] | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the completion date. */
    CompletionDate?: string | undefined;
    /** Gets or sets the array of approver oids assigned to the approval. */
    Approvers?: string[] | undefined;
    /** Gets or sets the list of prinicpals involved with the approval. */
    Principals?: UserPrincipal[] | undefined;
    /** Gets or sets the list of attachment metadata associated with the approval. */
    Attachments?: ApprovalAttachmentDefinition[] | undefined;
    /** Gets or sets the approval type. */
    ApprovalType: ApprovalType;
    /** Gets or sets the links used to review an envelope for esign. */
    EsignReviewLinks?: ApprovalAttachmentDefinition[] | undefined;
    /** Gets or sets the request type. */
    RequestType: ApprovalRequestType;
    /** Gets or sets the category of the approval. */
    Category?: string | undefined;
    /** Gets or sets the Id of the template with which the approval is created. */
    TemplateId?: string | undefined;
    /** Gets or sets the Id of the form in the template with which the approval is created. */
    TemplateFormId?: string | undefined;
    /** Gets or sets the Id of the form response user sumbitted to create the approval. */
    TemplateResponseId?: string | undefined;
    /** Gets or sets the ApprovalTemplateInstanceBasicView. Only for templated approvals. */
    TemplateInstance?: ApprovalTemplateInstanceBasicView | undefined;
    /** Gets or sets the key value pairs of Form response details. */
    FormResponseDetails?: KeyValuePairOfStringAndString[] | undefined;
    /** Gets or sets the PartnerId.
            
Note: for legacy approvals, this property is the hashed value of the PartnerId instead of the original value. */
    PartnerId?: string | undefined;
    /** Gets or sets the PartnerMetadata Object. */
    PartnerMetadata?: ApprovalsPartnerMetadata | undefined;
    /** Gets or sets generic additional view properties. */
    AdditionalViewProperties?: { [key: string]: any; } | undefined;
    /** Gets or sets approval external id. */
    ExternalId?: string | undefined;
    /** Gets or sets the source of the approval. */
    Source?: string | undefined;
    /** Gets or sets the priority of the approval. */
    Priority?: Priority | undefined;
    /** Gets or sets current approval step number. */
    CurrentStepNumber?: number | undefined;
    /** Gets or sets the approval's additional fields. */
    AdditionalFields?: AdditionalField[] | undefined;
}

/** Approval response types. */
export enum ApprovalResponseType {
    NotSpecified = "NotSpecified",
    Basic = "Basic",
    BasicAwaitAll = "BasicAwaitAll",
    CustomResponse = "CustomResponse",
    CustomResponseAwaitAll = "CustomResponseAwaitAll",
    Sequential = "Sequential",
}

/** The role of a user in an approval. */
export enum ApprovalUserRole {
    NotSpecified = "NotSpecified",
    Owner = "Owner",
    Approver = "Approver",
    DelegatedAccess = "DelegatedAccess",
}

/** The UserPrincipal object. */
export interface UserPrincipal {
    /** Gets or sets the principal id. */
    Id?: string | undefined;
    /** Gets or sets the principal display name. */
    DisplayName?: string | undefined;
    /** Gets or sets the principal email. */
    Email?: string | undefined;
    /** Gets or sets the principal object tenant id. */
    TenantId?: string | undefined;
    /** Gets or sets the user principal name. */
    UserPrincipalName?: string | undefined;
    /** Gets or sets the base64 encoded thumbnail photo uri. */
    ThumbnailPhoto?: string | undefined;
    /** Gets or sets the principal object type. */
    Type?: PrincipalObjectType | undefined;
}

/** The principal object type enumeration. */
export enum PrincipalObjectType {
    NotSpecified = "NotSpecified",
    User = "User",
    Group = "Group",
    Claims = "Claims",
    DelegatedAdmin = "DelegatedAdmin",
    ServicePrincipal = "ServicePrincipal",
}

/** The ApprovalRequestViewDefinition from Flow. */
export interface ApprovalRequestViewDefinition {
    /** Gets or sets the stage of the name of the approval request. */
    Name?: string | undefined;
    /** Gets or sets the stage of the associated approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the user to which this request is assigned. */
    AssignedTo?: UserPrincipal | undefined;
    /** Gets or sets a value indicating whether the approval request may be reassigned. */
    AllowReassignment?: boolean | undefined;
    /** Gets or sets a value indicating whether the approval request has been reassigned. */
    IsReassigned?: boolean | undefined;
    /** Gets or sets the name of the approval request from which this was reassigned. */
    ReassignedFrom?: string | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the schema of the additional data that the approver may provide. */
    AdditionalParametersSchema?: any | undefined;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the partner metadata. */
    PartnerMetadata?: ApprovalRequestPartnerMetadata | undefined;
}

/** The stage of an approval or an approval request. */
export enum ApprovalStage {
    NotSpecified = "NotSpecified",
    Basic = "Basic",
    Complete = "Complete",
}

/** PartnerMetadata Object for Approval request. */
export interface ApprovalRequestPartnerMetadata {
    /** Gets or sets the datetime when approval request was last viewed. */
    LastViewedOn?: string | undefined;
    /** Gets or sets the datetime when requester was last notified. */
    LastNotifiedOn?: string | undefined;
    /** Gets or sets the custom status of the approval request. */
    Status?: string | undefined;
}

/** Output data object for get approval controller. */
export interface ApprovalRequestHistoryDefinition {
    /** Gets or sets the name of the approval request. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval request. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval request. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval request. */
    Properties?: ApprovalRequestHistoryProperties | undefined;
}

/** The ApprovalRequestHistoryDefinition. */
export interface ApprovalRequestHistoryProperties {
    /** Gets or sets the stage of the associated approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the user to which this request is assigned. */
    AssignedTo?: UserPrincipal | undefined;
    /** Gets or sets the notification frequency. */
    NotificationFrequency: number;
    /** Gets or sets a value indicating whether the approval request may be reassigned. */
    AllowReassignment?: boolean | undefined;
    /** Gets or sets a value indicating whether the approval request has been reassigned. */
    IsReassigned?: boolean | undefined;
    /** Gets or sets the name of the approval request from which this was reassigned. */
    ReassignedFrom?: ApprovalRequestHistoryDefinition | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the response option type. */
    ResponseOptionsType?: string | undefined;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the partner metadata. */
    PartnerMetadata?: ApprovalRequestPartnerMetadata | undefined;
}

/** The approval stage view definition. This definition is an abstraction of the requests and responses per a specific stage of an approval. Used as an array of approval stage view definitions to form a timeline of each stage of an approval. */
export interface ApprovalStageViewDefinition {
    /** Gets or sets the name of the stage of the approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the responses of the stage of the approval. */
    Responses?: ApprovalResponseViewDefinition[] | undefined;
}

/** The approval response view definition. This is a translation of the approval response entity into an object better suited to be consumed by the UI. This does not use any of the standard ARM properties present in the non-view versions as this definition. This is also used to select an audience of the approval notification in case, where partially approved request was followed with reminder notification request. */
export interface ApprovalResponseViewDefinition {
    /** Gets or sets the creation date. */
    CreationDate: string;
    /** Gets or sets the owner. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets the approver's response. */
    Response?: string | undefined;
    /** Gets or sets the approver's comments. */
    Comments?: string | undefined;
    /** Gets or sets the additional data that the approver may provide. */
    AdditionalParameters?: { [key: string]: any; } | undefined;
    /** Gets or sets the Order of response. */
    Order: number;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the additional fields. */
    AdditionalFields?: { [key: string]: string; } | undefined;
}

/** The approval item definition. */
export interface ApprovalItemDefinition {
    /** Gets or sets the link to the item to approve. */
    Link?: string | undefined;
    /** Gets or sets the display name for the item link. */
    DisplayName?: string | undefined;
}

/** Link attachments that require to be approved. */
export interface ApprovalsTextAttachment {
    /** Gets or sets the subject. */
    Subject?: string | undefined;
    /** Gets or sets the link. */
    NoteText?: string | undefined;
}

/** The approval definition. */
export interface ApprovalAttachmentDefinition {
    /** Gets or sets the unqiue identifier. */
    Id?: string | undefined;
    /** Gets or sets the name. */
    Name?: string | undefined;
    /** Gets or sets the link. */
    Link?: string | undefined;
}

/** The types of approvals that users can create, maps to the Request type drop down in UI. */
export enum ApprovalType {
    Basic = "Basic",
    ESign = "ESign",
    Templated = "Templated",
}

/** Approval Request Type. */
export enum ApprovalRequestType {
    NotSpecified = "NotSpecified",
    Other = "Other",
    Basic = "Basic",
    Esign = "Esign",
    Templates = "Templates",
}

/** Data model of the basic info of the ApprovalTemplateInstance. */
export interface ApprovalTemplateInstanceBasicView {
    /** Gets or sets the title of the template instance. */
    Title?: string | undefined;
    /** Gets or sets the description of the template instance. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the template instance. */
    IconName?: string | undefined;
    /** Gets or sets the icon color of the template instance. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the template instance. */
    Category: ApprovalTemplateCategory;
    /** Gets or sets the scope of the template instance. */
    Scope: ApprovalTemplateInstanceScopeType;
    /** Gets or sets the teamId of the template instance. this is actually the groupId of the team, and this field is only for Team scoped template instances. */
    TeamId?: string | undefined;
    /** Gets or sets whether the requests created by this template requires approvers comments, default to null. */
    IsApproverCommentsRequired?: boolean | undefined;
    /** Gets or sets the Id of form. */
    FormId?: string | undefined;
}

/** The enum definition of categories of ApprovalTemplateInstance. */
export enum ApprovalTemplateCategory {
    NotSpecified = "NotSpecified",
    Attendance = "Attendance",
    Administration = "Administration",
    Finance = "Finance",
    Activity = "Activity",
    OrderManagement = "OrderManagement",
    Personnel = "Personnel",
    Contract = "Contract",
    HealthCare = "HealthCare",
    WordAddin = "WordAddin",
}

/** The enum definition of ApprovalTemplateInstance scope. */
export enum ApprovalTemplateInstanceScopeType {
    Organization = "Organization",
    Team = "Team",
}

export interface KeyValuePairOfStringAndString {
    Key?: string | undefined;
    Value?: string | undefined;
}

/** PartnerMetadata Object for Approvals. */
export interface ApprovalsPartnerMetadata {
    /** Gets or sets approvalsTemplateResponse details. */
    ApprovalsTemplateResponse?: ApprovalsTemplateResponseItem[] | undefined;
    /** Gets or sets the viva amplify additional information. */
    VivaAmplifyAdditionalDetails?: VivaAmplifyAdditionalDetails | undefined;
    /** Gets or sets the Syntex Esign additional information. */
    SyntexESignMetadata?: SyntexESignMetadata | undefined;
    /** Gets or sets other properties in the metadata.
It's preferred to define a strong type property when you add a new field in the metadata. */
    AdditionalData?: { [key: string]: any; } | undefined;
}

/** ResponseItem (Answer + Question Snapshot) for Template Approvals. */
export interface ApprovalsTemplateResponseItem {
    /** Gets or sets id map the form question. */
    questionId?: string | undefined;
    /** Gets or sets question type. */
    type: TemplateQuestionType;
    /** Gets or sets question anwser string or jsonstring. */
    answer?: string | undefined;
    /** Gets or sets question title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this field is required. */
    required: boolean;
    /** Gets or sets all choices of the question. */
    chocies?: string[] | undefined;
    /** Gets or sets Froms Rich Text Title. */
    formsProRTQuestionTitle?: string | undefined;
}

/** Quesiton Type. Save and transfer this data as string. [EnumMember(Value = "xx")] dose not work with System.Text.Json. So we use under line to split subtype.the enum filed name cannot be changed once published. */
export enum TemplateQuestionType {
    TextField_Single = "TextField_Single",
    TextField_Multiline = "TextField_Multiline",
    Choice_SingleRadio = "Choice_SingleRadio",
    Choice_SingleDropdown = "Choice_SingleDropdown",
    Choice_MultiCheckbox = "Choice_MultiCheckbox",
    DateTime_Default = "DateTime_Default",
    TextField_Number = "TextField_Number",
}

/** Addtional details for the Viva Amplify approvals. */
export interface VivaAmplifyAdditionalDetails {
    /** Gets or sets the teams Id. */
    teamsId?: string | undefined;
    /** Gets or sets the Channel id. */
    channelId?: string | undefined;
    /** Gets or sets the publish date of the item in UTC format. */
    scheduledPublishDate?: string | undefined;
    /** Gets or sets the approval type of the viva campaign communication. */
    approvalType?: string | undefined;
    /** Gets or sets the message from the requestor. */
    messageFromRequestor?: string | undefined;
    /** Gets or sets the distribution channel. */
    distributionChannel?: DistributionChannel[] | undefined;
    /** Gets or sets the publish option for Item. */
    publishOption?: PublishOption | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemTitle?: string | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemAbstract?: string | undefined;
    /** Gets or sets the url of the campaign approval item. */
    itemUrl?: string | undefined;
    /** Gets or sets the preview image of the campaign approval item. */
    itemPreviewImageUrl?: string | undefined;
}

/** Enum for the distribution channels. */
export enum DistributionChannel {
    Outlook = "outlook",
    Sharepoint = "sharepoint",
    Teams = "teams",
    VivaEngage = "vivaengage",
}

/** Enum for the publish option. */
export enum PublishOption {
    ScheduledFor = "scheduledFor",
    PublishOnceApproved = "publishOnceApproved",
    ReviewBeforePublish = "reviewBeforePublish",
}

/** Additional Details for Syntex Esign Approvals. */
export interface SyntexESignMetadata {
    /** Gets or sets the locale for the approval. */
    Locale?: string | undefined;
    /** Gets or sets the target folder for the Esign documents. */
    TargetFolder?: string | undefined;
    /** Gets or sets the documents associated with the approval. */
    Documents?: SyntexESignDocument[] | undefined;
    /** Gets or sets the message associated with the approval. */
    Message?: string | undefined;
    /** Gets or sets the status associated with the approval. */
    Status?: number | undefined;
}

/** Syntex Esign Document Object. */
export interface SyntexESignDocument {
    /** Gets or sets the name of the Syntex document. */
    Name?: string | undefined;
    /** Gets or sets the Uri for the Syntex document. */
    Uri?: string | undefined;
}

/** The priority of the approval. */
export enum Priority {
    Low = "Low",
    Medium = "Medium",
    Important = "Important",
}

export interface AdditionalField {
    /** Gets or sets the id of the additional field. */
    Id?: string | undefined;
    /** Gets or sets the title of the additional field. */
    Title?: string | undefined;
    /** Gets or sets the description of the additional field. */
    Description?: string | undefined;
    /** Gets or sets the content of the additional field. */
    Content?: string | undefined;
}

/** Data object used to call the create approval handler. */
export interface CreateApprovalControllerInput2 {
    /** Gets or sets the creator of approval request. */
    Creator?: ApprovalCreator | undefined;
    /** Gets or sets the Name of user. */
    UserName?: string | undefined;
    /** Gets or sets the Email of user. */
    UserEmail?: string | undefined;
    /** Gets or sets the title. */
    Title?: string | undefined;
    /** Gets or sets the users AadId to which the approval is assigned. An array of user AadIds. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the type of approval to create. */
    Type: ApprovalResponseType;
    /** Gets or sets the notification url. */
    CallbackUrls?: string[] | undefined;
    /** Gets or sets the details. */
    Details?: string | undefined;
    /** Gets or sets the item to approve. */
    Item?: ApprovalItem | undefined;
    /** Gets or sets the Text Attachment to approve. */
    TextAttachments?: ApprovalsTextAttachment[] | undefined;
    /** Gets or sets the response options for the custom response approval. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the ClientRequestId for approval request. */
    ClientRequestId: string;
    /** Gets or sets the Approval Type. */
    ApprovalType: ApprovalType;
    /** Gets or sets the logger properties for a scenario coming in from client-side. */
    ScenarioLoggerProperties?: AriaScenarioLoggerProperties | undefined;
    /** Gets or sets a value indicating whether the tenant is provisioning with this action. */
    FirstTimeProvisioning?: boolean | undefined;
    /** Gets or sets the environment in which Approval is created. */
    FlowEnvironment?: string | undefined;
    /** Gets or sets the Approvals User Token. This is used for bot context messages extension submit action. */
    UserToken?: string | undefined;
    /** Gets or sets the category of the approval. */
    Category?: string | undefined;
    /** Gets or sets the Id of the template with which the approval is created. */
    TemplateId?: string | undefined;
    /** Gets or sets the Id of the form response user submitted to create the approval. */
    TemplateResponseId?: string | undefined;
    /** Gets or sets the source of the approval. */
    Source?: string | undefined;
    /** Gets or sets the priority of the approval. */
    Priority?: Priority | undefined;
    /** Gets or sets the PartnerMetadata Object. */
    PartnerMetadata?: ApprovalsPartnerMetadata | undefined;
    /** Gets or sets the Steps Object. */
    Steps?: ApprovalStepSettingInput[] | undefined;
    /** Gets or sets the Answers of the report. */
    Answers?: AnswerByQuestion[] | undefined;
}

/** Base data object for creating an approval. */
export interface CreateApprovalControllerInput extends CreateApprovalControllerInput2 {
    /** Gets or sets the partner id. */
    PartnerId?: string | undefined;
    /** Gets or sets whether requests of an approval can be reassigned. */
    EnableReassignment?: boolean | undefined;
    /** Gets or sets the Isv associated with the approval. */
    IsvId?: string | undefined;
}

/** Creator of approval request. */
export enum ApprovalCreator {
    PersonalApp = "PersonalApp",
    ChatMessage = "ChatMessage",
    ChannelPost = "ChannelPost",
    WordAddIn = "WordAddIn",
    ApprovalGraph = "ApprovalGraph",
    UnSpecified = "UnSpecified",
}

/** Items that requires to be approved. */
export interface ApprovalItem {
    /** Gets or sets the item link. */
    Link?: string | undefined;
    /** Gets or sets the item link description. */
    LinkDescription?: string | undefined;
}

/** Aria logger properties received from client-side. */
export interface AriaScenarioLoggerProperties {
    /** Gets or sets the session ID. */
    SessionId: string;
    /** gets or sets the scenario name. */
    ScenarioName?: string | undefined;
    /** gets or sets the scenario name. */
    StepName?: string | undefined;
    /** gets or sets the status. */
    Status?: string | undefined;
    /** gets or sets the approval id. */
    ApprovalId?: string | undefined;
    /** gets or sets additional data received from telemetry logger. */
    Data?: any | undefined;
}

/** Settings for one step in Sequential approval. */
export interface ApprovalStepSettingInput {
    /** Gets or sets the users to which the approval is assigned as approvers.
An array of Object IDs or Emails. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the approval policy. */
    ApprovalPolicy: ApprovalPolicyType;
}

/** The approval policy: any ,all. */
export enum ApprovalPolicyType {
    Any = "Any",
    All = "All",
}

/** The data model of AnswerByQuestion. The answer can be identified by the question id in a report context. */
export interface AnswerByQuestion {
    /** Gets or sets the QuestionId. */
    QuestionId?: string | undefined;
    /** Gets or sets the AnswerContent. */
    AnswerContent?: string | undefined;
}

/** Input data object for create approvals group controller. */
export interface CreateApprovalsGroupControllerOutput {
    /** Gets or sets the partner id for the approvals group. */
    PartnerId: string;
}

/** Input data object for create approvals group controller. */
export interface CreateApprovalsGroupControllerInput {
    /** Gets or sets the group id for the approvals group. */
    GroupId: string;
}

/** Data object outlining response from flow's listApproval API. */
export interface ListApprovalsControllerOutput {
    /** Gets or sets the approval view definition. */
    Value?: ApprovalViewDefinition[] | undefined;
    /** Gets or sets the next link to query to get the remaining results. */
    NextLink?: string | undefined;
}

/** The approval view definition. The properties of this definition are a translation of the approval entity into an object better suited to be consumed by the UI. */
export interface ApprovalViewDefinition {
    /** Gets or sets the name of the approval view. */
    Name?: string | undefined;
    /** Gets or sets the properties of the approval view. */
    Properties?: ApprovalViewProperties | undefined;
}

/** The approval category. */
export enum ApprovalCategory {
    NotSpecified = "NotSpecified",
    Basic = "Basic",
    Custom = "Custom",
}

/** Output data object for Update Action controller. */
export interface UpdateActionControllerOutput {
    /** Gets or sets the returned adaptive card from 3p app. */
    AdaptiveCard?: any | undefined;
}

/** Data object used to call the Update action controller. */
export interface UpdateActionControllerInput {
    /** Gets or sets a value indicating what endpoint to hit to update the action take. */
    UpdateActionUri: string;
    /** Gets or sets a value indicating which LOB app config to use. */
    Provider: ClientProviderType;
    /** Gets or sets the data payload to be sent along to update the approval. */
    DataPayload: any;
}

/** Data object outlining response from flow's responseApproval API. */
export interface UpdateApprovalControllerOutput {
    /** Gets or sets the name of the approval response. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval response. */
    Id?: string | undefined;
    /** Gets or sets the entity type name, for this case it would be ApprovalResponse. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval. */
    Properties?: UpdateApprovalOutputProperties | undefined;
}

/** Data object of the properties of the update response from flow. */
export interface UpdateApprovalOutputProperties {
    /** Gets or sets stage of the approval. */
    Stage?: string | undefined;
    /** Gets or sets status of the response. */
    Status: ApprovalResponseStatus;
    /** Gets or sets creation date of the approval. */
    CreationDate: string;
    /** Gets or sets the identity of the user that responds. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets response of the approval. */
    Response?: string | undefined;
    /** Gets or sets comments of the approval. */
    Comments?: string | undefined;
}

/** The state of an approval response. */
export enum ApprovalResponseStatus {
    NotSpecified = "NotSpecified",
    Reviewing = "Reviewing",
    Saved = "Saved",
    Committed = "Committed",
}

/** Data object used to call the update approval handler. */
export interface UpdateApprovalControllerInput2 {
    /** Gets or sets the approval Id. */
    ApprovalId: string;
    /** Gets or sets the input properties of an update (response) call. */
    Properties?: UpdateApprovalInputProperties | undefined;
    /** Gets or sets the ClientRequestId for approvalrequest. */
    ClientRequestId: string;
    /** Gets or sets the environment id for Approval is created. */
    FlowEnvironment?: string | undefined;
}

/** Data object used to call the update approval handler. */
export interface UpdateApprovalControllerInput extends UpdateApprovalControllerInput2 {
    /** Gets or sets the Isv Id. */
    IsvId?: string | undefined;
}

/** Properties of the data object used to call the update (response) approval handler. */
export interface UpdateApprovalInputProperties {
    /** Gets or sets the response of the approval. */
    Response?: string | undefined;
    /** Gets or sets the comment of the approval. */
    Comments?: string | undefined;
    /** Gets or sets the additional field responses. */
    AdditionalFields?: { [key: string]: string; } | undefined;
}

/** The data model of AsyncOperation. */
export interface GetOperationControllerOutput {
    /** Gets or sets the Id of operation. */
    OperationId: string;
    /** Gets or sets the UserId of the user who created the operation. */
    UserId: string;
    /** Gets or sets the TenantId of the user who created the operation. */
    TenantId: string;
    /** Gets or sets the timestamp when the operation was created. */
    CreatedAt: string;
    /** Gets or sets the timestamp when the operation was last updated. */
    UpdatedAt: string;
    /** Gets or sets the type of operation. */
    Type: AsyncOperationType;
    /** Gets or sets the result of the operation, only available when Status=Succeeded. */
    Result?: AsyncOperationResult | undefined;
    /** Gets or sets the error of the operation, only available when Status=Failed. */
    Error?: AsyncOperationError | undefined;
    /** Gets or sets the status of operation. */
    Status: AsyncOperationStatus;
}

export enum AsyncOperationType {
    CreateApproval = "CreateApproval",
    CancelApproval = "CancelApproval",
    RespondApproval = "RespondApproval",
}

export interface AsyncOperationResult {
    ApprovalId?: string | undefined;
    EnvironmentName?: string | undefined;
}

/** Error class for async operation. */
export interface AsyncOperationError {
    /** Gets or sets the error message. */
    ErrorMessage?: string | undefined;
    /** Gets or sets the status code. */
    StatusCode: HttpStatusCode;
    /** Gets or sets the inner error. */
    InnerException?: AsyncOperationInnerError | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Moved = "MovedPermanently",
    Found = "Found",
    Redirect = "Found",
    SeeOther = "SeeOther",
    RedirectMethod = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    UnprocessableContent = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

/** Inner error class for async operation. */
export interface AsyncOperationInnerError {
    /** Gets or sets the error code. */
    ErrorCode?: string | undefined;
}

export enum AsyncOperationStatus {
    NotSpecified = "NotSpecified",
    Scheduled = "Scheduled",
    InProgress = "InProgress",
    Succeeded = "Succeeded",
    Failed = "Failed",
    Timeout = "Timeout",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ServiceException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isServiceException = true;

    static isServiceException(obj: any): obj is ServiceException {
        return obj.isServiceException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ServiceException(message, status, response, headers, null);
}

/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 *
 *  Base Class for auto-generated nSwag code under `../gen/index.ts`. The code in this file can be modified if needed,
 *  but make sure to run the build of Approvals.SFApp/Approvals.Service to update the auto-generated code, and check in
 *  the auto-generated code as well.
 *
 *  The auto-generated code under `../gen/index.ts` is the code that actually gets to run.
 */

declare const EXTENSIBILITY_SERVICE_ENDPOINT: string;